<template>
  <div class="block">
    <div class="reorder">
      <a href="#" v-on:click="$emit('moveDown', data)" class="move-up">&uarr;</a>
      <a href="#" v-on:click="$emit('moveUp', data)" class="move-down">&darr;</a>
    </div>
    <a href="#" v-on:click="$emit('deleteBlock', data)" class="delete nested">x</a>
    <label class="underline">HTML block</label>
    <div class="row">
      <div class="field">
        <label>Style</label>
        <div class="field">
          <label class="label">Background colour</label>
          <div class="control">
            <input class="input" type="text" placeholder="#cccccc" v-model="data.styles_background_colour" />
          </div>
          <label class="label">Font colour</label>
          <div class="control">
            <input class="input" type="text" placeholder="#000000" v-model="data.styles_font_colour" />
          </div>
        </div>
        <div class="field text-field">
          <label class="label">HTML</label>
          <div class="control">
            <textarea v-model="data.content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firestore } from '../main'

export default {
  name: 'Edit-HtmlBlock',
  props: ['data'],
  updated: function() {
    if (!this.data) return
    this.$emit('updateBlock', this.data)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-field {
    flex: 2;
  }
  textarea {
    color: #555;
    font-family: courier, monospace;
    font-size: 90%;
    height: 30rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Edit-HtmlBlock.vue